export const ChatsLayoutTemplate = `
    {{{chatlist}}}
    {{{chat}}}
`;
